/**
 * CGCBanReasonsPage — iter-269 (Feb 2026)
 * =========================================
 * Standalone page wrapping BanReasonsManager for the CGC customer
 * platform's ban-reasons dropdown. Mounted at
 *   /control/cloudgm/customer-dropdowns/ban-reasons
 */
import DashboardHeader from '../components/DashboardHeader';
import BreadcrumbNav from '../components/BreadcrumbNav';
import { useLanguage } from '../context/LanguageContext';
import BanReasonsManager from './manage-platform/BanReasonsManager';

export default function CGCBanReasonsPage() {
  const { language } = useLanguage();
  const isAr = language === 'ar';
  const t = (ar, en) => (isAr ? ar : en);

  return (
    <div className="min-h-screen bg-[#030303]" dir={isAr ? 'rtl' : 'ltr'}>
      <DashboardHeader showBackButton backPath="/control/cloudgm/customer-dropdowns" />

      <div className="border-b border-white/5">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <BreadcrumbNav items={[
            { label_ar: 'لوحة التحكم', label_en: 'Dashboard', path: '/dashboard' },
            { label_ar: 'CLOUDGM FZ LLC (للتحكم)', label_en: 'CLOUDGM FZ LLC (Control)', path: '/dashboard?view=platform-control&sub=fzlc' },
            { label_ar: 'التحكم والمعلومات (منصة العملاء)', label_en: 'Control & Info (Customers)', path: '/control/cloudgm' },
            { label_ar: 'القوائم المنسدلة للتحكم بمنصة العملاء', label_en: 'Customer Platform Dropdown Lists', path: '/control/cloudgm/customer-dropdowns' },
            { label_ar: 'أسباب حظر الحساب (منصة العملاء)', label_en: 'Customer Ban Reasons', path: null },
          ]} />
        </div>
      </div>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-white">
            {t('أسباب حظر الحساب (منصة العملاء)', 'Customer Ban Reasons')}
          </h1>
          <p className="text-sm text-white/50 mt-1 max-w-2xl">
            {t(
              'أسباب تظهر في نافذة حظر العميل. لا يمكن حذف "أخرى" — عند اختيارها في نافذة الحظر يفتح مربع ملاحظات مع زر ترجمة.',
              'Reasons shown in the customer block modal. "Other" is locked — selecting it opens a free-text notes field with a translate button.',
            )}
          </p>
        </div>
        <BanReasonsManager
          reasonType="cgc_ban_reason"
          language={language}
          accentColor="red"
        />
      </main>
    </div>
  );
}
